module.exports = __webpack_public_path__ + "media/icons/chevron-right-c170fd48.svg";